// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-b080ef10]{width:60vw}@media (max-width:1023px){.chart[data-v-b080ef10]{width:75vw}}@media (max-width:767px){.chart[data-v-b080ef10]{width:70vw}}@media (max-width:639px){.chart[data-v-b080ef10]{width:60vw}}", ""]);
// Exports
module.exports = exports;
